/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Flex, Group, useMantineTheme } from '@mantine/core';
import { clamp } from 'es-toolkit';
import type { ComponentProps } from 'react';

import SuiteLogo from '@fai/friendli-suite/views/layout/header/items/suite-logo';

export function PortalLogo({
  zIndex,
  navbarOpened,
  logoPath,
  constants,
  scrollTop,
}: {
  navbarOpened: boolean;
  zIndex: number;
  logoPath: ComponentProps<typeof SuiteLogo>['path'];
  scrollTop: number;
  constants: {
    mainHeaderHeight: number;
    subHeaderHeight: number;
    originalLogoSize: number;
    pinnedLogoSize: number;
  };
}) {
  const theme = useMantineTheme();
  const { mainHeaderHeight, subHeaderHeight, originalLogoSize, pinnedLogoSize } = constants;

  return (
    <Group
      style={{
        height: mainHeaderHeight - clamp(scrollTop, 0, mainHeaderHeight - subHeaderHeight),
        position: 'fixed',
        top: 0,
        left: theme.pf.layout.md,
        zIndex,
      }}
    >
      <Flex align="center" display="flex" h="100%" justify="center" w={originalLogoSize}>
        <SuiteLogo
          path={logoPath}
          size={
            navbarOpened
              ? originalLogoSize
              : originalLogoSize - clamp(scrollTop, 0, originalLogoSize - pinnedLogoSize)
          }
        />
      </Flex>
    </Group>
  );
}
